export default {
  path: '/ticket_origins',
  name: 'ticket_origin',
  component: () => import('../components/ticketorigin/Layout'),
  redirect: { name: 'TicketoriginList' },
  meta: {
    breadcrumb: 'ticket.ticketorigins',
  },
  children: [
    {
      name: 'TicketoriginList',
      path: '',
      component: () => import('../views/ticketorigin/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'TicketoriginCreate',
      path: 'new',
      component: () => import('../views/ticketorigin/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'TicketoriginUpdate',
      path: ':id/edit',
      component: () => import('../views/ticketorigin/Update'),
      meta: {
        breadcrumb: 'ticket.ticketorigin',
      },
    },
    {
      name: 'TicketoriginShow',
      path: ':id',
      component: () => import('../views/ticketorigin/Show'),
      meta: {
        breadcrumb: 'ticket.ticketorigin',
      },
    }
  ]
};
